import { styled } from 'styled-components'

import { ProfileRole } from '../../types'

export const MusicPlayerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  gap: 10px;
  -webkit-box-shadow: 0px 0px 37px -16px rgba(145, 145, 145, 1);
  -moz-box-shadow: 0px 0px 37px -16px rgba(145, 145, 145, 1);
  box-shadow: 0px 0px 37px -16px rgba(145, 145, 145, 1);
  padding: 40px;
  border-radius: 20px;
  background-color: #ffffff;

  @media screen and (max-width: 768px) {
    padding: 20px 20px;
    box-shadow: none;
    border: 1px solid #eeecec;
  }
`

export const MusicPlayerButtons = styled.div`
  -webkit-box-shadow: 0px 5px 35px -16px rgba(145, 145, 145, 1);
  -moz-box-shadow: 0px 5px 35px -16px rgba(145, 145, 145, 1);
  box-shadow: 0px 5px 35px -16px rgba(145, 145, 145, 1);
  padding: 15px 30px;
  border-radius: 20px;
  background-color: #ffffff;
  width: 440px;
  height: 110px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 15px;

  @media screen and (max-width: 768px) {
    width: 390px;
    padding: 15px;
  }
`

export const MusicPlayerDisc = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  /* background-image: url('/assets/tocadisco/tocadisco.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain; */
  /* background-color: bisque; */
  height: 180px;
  width: 287px;
  align-self: center;
  position: relative;

  .disc-base {
    position: absolute;
    height: 132px;
    width: 132px;
    border-radius: 50%;
    /* left: -44px; */
    /* top: -11px; */
    background-color: #aaaaaa;
  }

  .disco {
    /* height: 150px;
    width: 150px; 
    left: 40px;
    position: absolute;*/

    background-image: url('/assets/tocadisco/disco.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50%;
    overflow: hidden;
    transition-delay: 3s;
    width: 130px;
    height: 130px;
    position: relative;
    left: 0;
    /* -webkit-box-shadow: 4px 4px 0px -1px #aaaaaa;
    box-shadow: 4px 4px 1px -1px #aaaaaa; */

    @keyframes girar {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }

  .pua {
    position: absolute;
    background-image: url('/assets/tocadisco/pua.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 120px;
    width: 100px;
    right: 45px;
    top: 10px;
    transform-origin: top right;

    /* transform: rotate(-30deg); */

    transform: rotate(-30deg);
    transition: transform 1s ease-in-out;
  }

  .volume {
    position: absolute;
    top: 95px;
    right: 55px;
    width: 35px;
    height: 55px;
    padding: 5px;
    border-radius: 5px;
    background-image: url('/assets/tocadisco/volume.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
`

export const PlayerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 0 20px;
  align-items: center;

  p {
    font-size: 12px;
    font-weight: 500;
    color: #54577a;
  }
`

export const PlayerButtons = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 23px;

  button {
    padding: 0;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    color: #0a0a18;
    border: none;

    &:focus {
      outline: none;
    }
  }

  .prev,
  .next {
    font-size: 25px;
    display: flex;
    align-items: center;
    width: 25px;
  }

  .play {
    font-size: 50px;

    position: relative;

    /* background-color: #0a0a18;
    color: #ffffff; */
    div {
      position: absolute;
      width: 41px;
      height: 41px;
      border-radius: 50%;
      -webkit-box-shadow: 0px 9px 15px -4px rgba(71, 71, 71, 1);
      -moz-box-shadow: 0px 9px 15px -4px rgba(71, 71, 71, 1);
      box-shadow: 0px 9px 15px -4px rgba(71, 71, 71, 1);
    }
  }
`

export const TimerSection = styled.div`
  display: flex;
  justify-content: space-between;
  color: #55b5df;
  font-size: 16px;
  font-weight: 500;
`

export const MusicProgression = styled.div`
  position: relative;
  width: 100%;
  height: 5px;
  background-color: #f6f6f6;
  cursor: pointer;

  div {
    position: absolute;
    height: 100%;
    background-color: #55b5df;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .player-circle {
    border-radius: 50%;
    background-color: #55b5df;
    width: 12px;
    height: 12px;
    border: 2px solid #ffffff;
    right: -1px;
  }
`

export const SongList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 320px;
  gap: 20px;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 0 15px;
  }
`

export const List = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
`

export const ListItem = styled.div<{
  $studentVisibility?: boolean
  $userRole: ProfileRole | null
}>`
  align-items: center;
  display: ${(props) => (props.$studentVisibility === false ? 'none' : 'flex')};
  width: 100%;

  .item {
    display: grid;
    grid-template-columns: ${(props) =>
      props.$userRole === 'student' ? '30px 1fr 35px' : '35px 1fr 35px'};
    gap: 9px;
    align-items: center;
    background-color: #f6f6f6;
    border-radius: 10px;
    padding: 10px 11px;
    width: 100%;
    font-weight: 400;
    font-size: 14px;

    .image {
      border-radius: 50%;
      width: 30px;
      height: 30px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
      background-image: url('/assets/tocadisco/disco.png');
    }

    .play {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 40px;

      div {
        position: absolute;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        -webkit-box-shadow: 0px 9px 30px -4px rgba(71, 71, 71, 1);
        -moz-box-shadow: 0px 9px 30px -4px rgba(71, 71, 71, 1);
        box-shadow: 0px 9px 30px -4px rgba(71, 71, 71, 1);
      }
    }

    .delete-button {
      border-radius: 50%;
      width: 35px;
      height: 35px;
      font-size: 26px;
      border: 1px solid;
      background: none;
      font-weight: 600;
      display: flex;
      justify-content: center;
      gap: 5px;
      align-items: center;
      z-index: 9999;

      /* div {
        height: 35px;

        width: 35px;
        line-height: 0px;
      }
      span {
        font-size: 10px;
      } */
    }

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`
export const Equalizer = styled.div<{ $isPlaying: boolean }>`
  display: flex;
  gap: 2px;
  height: 20px;
  width: 20px;
  transform: rotate(180deg);

  .bar {
    width: 4px;
    background-color: #55b5df;
    animation: bounce 1s infinite ease-in-out;
    animation-play-state: ${(props) =>
      props.$isPlaying ? 'running' : 'paused'};
  }

  .bar:nth-child(2) {
    animation-delay: 0.2s;
  }
  .bar:nth-child(3) {
    animation-delay: 0.4s;
  }

  .bar:nth-child(4) {
    animation-delay: 0.6s;
  }

  @keyframes bounce {
    0%,
    100% {
      height: 4px;
    }
    50% {
      height: 20px;
    }
  }
`
